import React from 'react'
import { wrapView } from '../smart_bps/lib/utils'
import { stateToPropsSigur } from '../lib/stateToPropsSigur'
import { PROJECT_NAME } from './constants'
import AutoparkShowroomView from './showroom_view'

class ModelView extends React.Component {
  render() {
    return <AutoparkShowroomView />
  }
}

export default wrapView(ModelView, (state) => stateToPropsSigur(state, PROJECT_NAME))
